import React, {Component} from "react";
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {BookUnitStates} from "./types/BookUnitTypes";
import withAuth from "../../hoc/withAuth";
import {Alert, Button, Card, Col, Collapse, DatePicker, Divider, Form, Input, Modal, Row, Spin} from "antd";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {stockApiService} from "../../services/otodis/StockApiService";
import Cookies from "universal-cookie";
import moment from "moment";
import {InfoCircleOutlined} from "@ant-design/icons";

const {Panel} = Collapse;

export interface BookUnitProps {
}

class BookUnit extends Component<BookUnitProps & any, BookUnitStates> {
    private readonly initState!: BookUnitStates;
    private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());

    constructor(props: (BookUnitProps & any) | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
            offerCode: "",
            offerCodeDate: "",
            stockNumber: "",
            updateProcess: false,
            updateProcessDate: false,
            stockClosingDate: moment(new Date(), "YYYY-MM-DD").add(1, "days"),
            modalConfirmBookNumber: false,
            fetchOfferAndEngine: false,
            dataDetailOffer: {},
            dataDetailStock: {},
            offerCodeRemove: "",
            updateRemoveDate: false,
            companyCode: companyCode
        };
        this.state = {...this.initState};
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value,
            offerCode: "",
            offerCodeDate: "",
            stockNumber: "",
            updateProcess: false,
            updateProcessDate: false,
            stockClosingDate: moment(new Date(), "YYYY-MM-DD"),
        });
    };

    onUpdateRemove = async () => {
        if (!this.state.offerCodeRemove) {
            Modal.error({
                title: "Proses Gagal",
                content: "Lengkapi data",
            });
            return;
        }

        const dataUpdate = {
            update_type: "stock-code",
            company: this.state.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCodeRemove?.trim(),
            remove_booking: true,
        };

        await this.promisedSetState({
            updateRemoveDate: true,
        });

        try {
            await offerApiServices.updateOffer(dataUpdate).then(async (successData) => {
                Modal.success({
                    title: "Proses Sukses",
                    content: "Offer berhasil di update ",
                });
                await this.promisedSetState({
                    updateRemoveDate: false,
                    offerCodeRemove: "",
                });
            });
        } catch (e) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda :" + e,
            });
            await this.promisedSetState({
                updateRemoveDate: false,
            });
        }
    };

    onUpdateDataDate = async () => {
        if (!this.state.offerCodeDate || !this.state.stockClosingDate) {
            Modal.error({
                title: "Proses Gagal",
                content: "Lengkapi data",
            });
            return;
        }

        const dataUpdate = {
            update_type: "stock-code",
            company: this.state.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCodeDate?.trim(),
            stock_closing_date: moment(this.state?.stockClosingDate).format("YYYY-MM-DD"),
        };

        await this.promisedSetState({
            updateProcessDate: true,
        });

        try {
            await offerApiServices.updateOffer(dataUpdate).then(async (successData) => {
                Modal.success({
                    title: "Proses Sukses",
                    content: "Offer berhasil di update ",
                });
                await this.promisedSetState({
                    updateProcessDate: false,
                    offerCodeDate: "",
                    stockClosingDate: moment(new Date(), "YYYY-MM-DD"),
                });
            });
        } catch (e) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda :" + e,
            });
            await this.promisedSetState({
                updateProcessDate: false,
            });
        }
    };

    showConfirmModalEngineNumber = async () => {
        if (!this.state.offerCode || !this.state.stockNumber) {
            Modal.error({
                title: "Proses Gagal",
                content: "Lengkapi data",
            });
            return;
        }

        await this.promisedSetState({
            modalConfirmBookNumber: true,
            updateProcess: true,
            fetchOfferAndEngine: true,
        });

        try {
            const dataOffer = await offerApiServices.getDetailOffer({offerCode: this.state.offerCode, companyCode: this.state.companyCode});
            await this.promisedSetState({dataDetailOffer: dataOffer.data.data});
        } catch (e: any) {
            Modal.error({
                title: "Proses Gagal",
                content: e?.response?.data?.message ?? "Error Kode Offer",
            });
            await this.promisedSetState({
                modalConfirmBookNumber: false,
                updateProcess: false,
                fetchOfferAndEngine: false,
            });
            return;
        }

        try {
            const dataStock = await stockApiService.getStock({vehicleEngineNumber: this.state.stockNumber});
            await this.promisedSetState({dataDetailStock: dataStock.data.data[0]});
        } catch (e: any) {
            let errorMsg = e?.toString();
            if (errorMsg === "Error: No Data") {
                errorMsg = "Error, Nomor Mesin tidak ditemukan"
            }
            Modal.error({
                title: "Proses Gagal",
                content: errorMsg,
            });
            await this.promisedSetState({
                modalConfirmBookNumber: false,
                updateProcess: false,
                fetchOfferAndEngine: false,
            });
            return;
        }

        await this.promisedSetState({
            updateProcess: false,
            fetchOfferAndEngine: false,
        });
    };

    onUpdateDataEngineNumber = async () => {
        const dataUpdate = {
            update_type: "stock-code",
            company: this.state.companyCode,
            admin_id: this.user,
            admin_name: this.user,
            offer_code: this.state.offerCode?.trim(),
            stock_number: this.state.stockNumber?.trim(),
            stock_code: "",
        };

        await this.promisedSetState({
            updateProcess: true,
        });

        try {
            await offerApiServices.updateOffer(dataUpdate).then(async (successData) => {
                Modal.success({
                    title: "Proses Sukses",
                    content: "Offer berhasil di update ",
                });
                await this.promisedSetState({
                    modalConfirmBookNumber: false,
                    updateProcess: false,
                    offerCode: "",
                    stockNumber: "",
                });
            });
        } catch (e) {
            Modal.error({
                title: "Proses Gagal",
                content: "Server Menolak Inputan Anda :" + e,
            });
            await this.promisedSetState({
                updateProcess: false,
            });
        }
    };

    onFieldChange = <T extends keyof Pick<any, "offerCode" | "offerCodeRemove" | "offerCodeDate" | "stockClosingDate" | "stockNumber">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "offerCode":
                currentState.offerCode = value?.trim();
                break;
            case "offerCodeRemove":
                currentState.offerCodeRemove = value?.trim();
                break;
            case "offerCodeDate":
                currentState.offerCodeDate = value?.trim();
                break;
            case "stockNumber":
                currentState.stockNumber = value?.trim();
                break;
            case "stockClosingDate":
                currentState.stockClosingDate = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    };

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Book Unit`} defaultSelectedKeys={["m-book-unit"]} defaultOpenKeys={["sm-sm-sys-offer", "sm-offer"]}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <div style={{padding: 20}}>
                        <Row>
                            <Col xs={24} xl={8}>
                                <Card title="Update Booking Nomor Mesin" style={{margin: 10}}>
                                    <Collapse ghost>
                                        <Panel
                                            header={
                                                <span>
                                                    {" "}
                                                    <InfoCircleOutlined style={{color: "#1890ff"}}/> <i>Aturan Booking Nomor Mesin ... </i>
                                                </span>
                                            }
                                            key="1"
                                        >
                                            <Alert
                                                message="Booking Nomor Mesin"
                                                description={
                                                    <div>
                                                        <ul>
                                                            <li>memprioritaskan pencocokan nomor mesin untuk sesi closing selanjutnya</li>
                                                            <li>tidak mengikat entitas nomor mesin, hanya menandai offer agar diclosing prioritas menggunakan nomor mesin yang dipilih untuk sesi closing terdekat.</li>
                                                            <li>
                                                                jika offer yang ditandai belum di QC pada sesi closing terdekat, nomor mesin bisa diambil oleh offer lain jika memang memenuhi syarat. offer yang ditandai akan menjadi
                                                                offer normal, dikarenakan nomor mesin telah digunakan offer lain.
                                                            </li>
                                                            <li>jika nomor mesin berbeda dengan offer / nomor mesin tidak dalam kondisi ACTIVE / offer tidak dalam keadaan OPEN, proses akan ditolak.</li>
                                                            <li>jika booking mesin x di dealer a, dan dealer a dalam state stop closing, closingan bisa diarahkan ke nomor mesin lain</li>
                                                        </ul>
                                                    </div>
                                                }
                                                type="info"
                                                showIcon
                                                style={{marginBottom: 10}}
                                            />
                                        </Panel>
                                    </Collapse>
                                    <br/>

                                    <Form layout="vertical">
                                        <Form.Item label="Kode Offer">
                                            <Input value={this.state.offerCode} placeholder="Kode Offer" onChange={(event) => this.onFieldChange("offerCode", event.target.value)}/>
                                        </Form.Item>
                                        <Form.Item label="Nomor Mesin">
                                            <Input value={this.state.stockNumber} placeholder="Nomor Mesin" onChange={(event) => this.onFieldChange("stockNumber", event.target.value)}/>
                                        </Form.Item>
                                        <br/>
                                        <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.showConfirmModalEngineNumber()}>
                                            {" "}
                                            Update Nomor Mesin
                                        </Button>
                                    </Form>
                                </Card>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Card title="Update Minimal Tanggal Pemenuhan" style={{margin: 10}}>
                                    <Form layout="vertical">
                                        <Collapse ghost>
                                            <Panel
                                                header={
                                                    <span>
                                                        {" "}
                                                        <InfoCircleOutlined style={{color: "#1890ff"}}/> <i>Aturan Minimal Tanggal Pemenuhan ... </i>
                                                    </span>
                                                }
                                                key="1"
                                            >
                                                <Alert
                                                    message="Efek setelah dilakukan"
                                                    description={
                                                        <div>
                                                            <ul>
                                                                <li>offer tidak akan diclosing / dipenuhi. sampai tanggal yang dipilih.</li>
                                                                <li>jika offer tidak dalam keadaan OPEN, proses akan ditolak.</li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    type="info"
                                                    showIcon
                                                    style={{marginBottom: 10}}
                                                />
                                            </Panel>
                                        </Collapse>
                                        <br/>

                                        <Form.Item label="Kode Offer">
                                            <Input value={this.state.offerCodeDate} placeholder="Kode Offer" onChange={(event) => this.onFieldChange("offerCodeDate", event.target.value)}/>
                                        </Form.Item>
                                        <Form.Item className={"padTop-7"} label={`Tanggal Minimal Pemenuhan`}>
                                            <DatePicker
                                                disabledDate={(current) => current && current <= moment().endOf("day")}
                                                value={moment(this.state.stockClosingDate, "YYYY-MM-DD")}
                                                onChange={(event) => this.onFieldChange("stockClosingDate", event)}
                                                format={"YYYY-MM-DD"}
                                                style={{width: "100%"}}
                                            />
                                        </Form.Item>
                                        <br/>
                                        <Button type={"primary"} loading={this.state.updateProcessDate} onClick={() => this.onUpdateDataDate()}>
                                            {" "}
                                            Update Tgl Pemenuhan
                                        </Button>
                                    </Form>
                                </Card>
                            </Col>

                            <Col xs={24} xl={8}>
                                <Card title="Remove Booking Mesin & Tanggal Pemenuhan" style={{margin: 10}}>
                                    <Form layout="vertical">
                                        <Collapse ghost>
                                            <Panel
                                                header={
                                                    <span>
                                                        {" "}
                                                        <InfoCircleOutlined style={{color: "#1890ff"}}/> <i>Aturan Remove Booking & Tanggal Pemenuhan ... </i>
                                                    </span>
                                                }
                                                key="1"
                                            >
                                                <Alert
                                                    message="Efek setelah dilakukan"
                                                    description={
                                                        <div>
                                                            <ul>
                                                                <li>menghilangkan flag nomor booking mesin dan tanggal minimal pemenuhan.</li>
                                                                <li>jika offer tidak dalam keadaan OPEN, proses akan ditolak.</li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    type="info"
                                                    showIcon
                                                    style={{marginBottom: 10}}
                                                />
                                            </Panel>
                                        </Collapse>
                                        <br/>

                                        <Form.Item label="Kode Offer">
                                            <Input value={this.state.offerCodeRemove} placeholder="Kode Offer" onChange={(event) => this.onFieldChange("offerCodeRemove", event.target.value)}/>
                                        </Form.Item>
                                        <br/>
                                        <Button type={"primary"} loading={this.state.updateRemoveDate} onClick={() => this.onUpdateRemove()}>
                                            {" "}
                                            Remove Booking
                                        </Button>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </MainLayout>

                <Modal
                    open={this.state.modalConfirmBookNumber}
                    title="Konfirmasi Booking Nomor Mesin"
                    onCancel={() => this.setState({modalConfirmBookNumber: false})}
                    cancelText={"Tutup"}
                    okText={false}
                    maskClosable={false}
                    closable={false}
                    footer={[
                        <Button type={"primary"} loading={this.state.updateProcess} key="1" onClick={this.onUpdateDataEngineNumber}>
                            Update Nomor Mesin
                        </Button>,
                        <Button loading={this.state.updateProcess} key="2" onClick={() => this.setState({modalConfirmBookNumber: false})}>
                            Close
                        </Button>,
                    ]}
                >
                    <div style={this.state.fetchOfferAndEngine ? {} : {display: "none"}} className={`spinCenter`}>
                        <Spin size="large"/>
                        <br/>
                        Fetching Data...
                    </div>

                    <div style={!this.state.fetchOfferAndEngine ? {} : {display: "none"}}>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Kode Offer:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailOffer?.transaction_code}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Brand: Model:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailOffer?.vehicle?.brand_name?.toUpperCase()} - {this.state.dataDetailOffer?.vehicle?.model_name?.toUpperCase()}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Variant:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailOffer?.vehicle?.variant_code?.toUpperCase()} - {this.state.dataDetailOffer?.vehicle?.variant_name?.toUpperCase()}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                KodeWarna / Tahun:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailOffer?.vehicle?.color_code} / {this.state.dataDetailOffer?.vehicle?.year}
                            </Col>
                        </Row>

                        <Divider/>

                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Nomor Mesin:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailStock?.vehicle_engine_number}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Brand: Model:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailStock?.vehicle_brand_name} {this.state.dataDetailStock?.vehicle_model_name}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Variant:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailStock?.vehicle_variant_code} - {this.state.dataDetailStock?.vehicle_variant_name}
                            </Col>
                        </Row>
                        <Row className={`pt-5`}>
                            <Col xs={24} xl={6} className={`col-grey-small-90`}>
                                Kode Warna / Tahun:
                            </Col>
                            <Col xs={24} xl={18}>
                                {this.state.dataDetailStock?.vehicle_color_code} - {this.state.dataDetailStock?.vehicle_year}
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default withAuth(withRouter(BookUnit), 30);